import { PrivecyPolicyAr, PrivecyPolicyEn } from "../features/terms/PrivecyPolicy";
import { TermsConditionsAr, TermsConditionsEn } from "../features/terms/TermsConditions";
import { useTranslation } from 'react-i18next';


export function Policy() {
    const { i18n } = useTranslation();

    return (
        <div className="container bg-light-gray my-4 rounded p-3 w-75 lh-lg"
            id="terms-accordion">
            {i18n.language === "ar" ?
                <PrivecyPolicyAr /> :
                <PrivecyPolicyEn />
            }
        </div>
    );
};

export function Terms() {
    const { i18n } = useTranslation();

    return (
        <div className="container bg-light-gray my-4 rounded p-3 w-75 lh-lg"
            id="terms-accordion">
            {i18n.language === "ar" ?
                <TermsConditionsAr /> :
                <TermsConditionsEn />}
        </div>
    );
};
